// Avatar.tsx

import React from "react";

// --- Avatar Component ---
interface AvatarProps {
    firstName: string;
    lastName: string;
    isActive: boolean;
    size: 'small' | 'medium' | 'large';
}

export const Avatar: React.FC<AvatarProps> = ({ firstName, lastName, isActive, size }) => {
    const sizeClasses = {
        small: 'w-8 h-8 text-xs',
        medium: 'w-10 h-10 text-sm',
        large: 'w-12 h-12 text-lg',
    };
    const activeClasses = isActive 
        ? "bg-blue-600 text-white" 
        : "bg-gray-400 text-white"; 

    return (
        <div className={`rounded-full flex items-center justify-center font-semibold uppercase ${sizeClasses[size]} ${activeClasses}`}>
            {firstName?.[0]}{lastName?.[0]}
        </div>
    );
};